import { useLanguage } from "./LanguageContext";

const CAMBRIA_URL = "https://www.choicehotels.com/reservations/groups/jw43f7?checkInDate=2026-07-01&checkOutDate=2026-07-03&ratePlanCode=BNCDYQ";
const RESIDENCE_INN_URL = "https://www.marriott.com/event-reservations/reservation-link.mi?id=1774546514896&key=GRP&app=resvlink";

function HotelCard({ name, rate, distance, buttonText, url }) {
  return (
    <div style={{
      background: "white",
      borderRadius: "16px",
      padding: "32px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      border: "1px solid var(--blue-100)",
      flex: "1 1 280px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: "12px",
    }}>
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ marginBottom: "4px" }}>
        <path d="M3 21V7a2 2 0 012-2h6v16M21 21V11a2 2 0 00-2-2h-4v12" stroke="var(--blue-400)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1 21h22" stroke="var(--blue-400)" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="7" y="9" width="2" height="2" rx="0.5" fill="var(--blue-300)" />
        <rect x="7" y="13" width="2" height="2" rx="0.5" fill="var(--blue-300)" />
        <rect x="15" y="13" width="2" height="2" rx="0.5" fill="var(--blue-300)" />
      </svg>
      <h3 style={{
        fontFamily: "'Playfair Display', serif",
        fontSize: "1.2rem",
        color: "var(--blue-800)",
      }}>
        {name}
      </h3>
      <p style={{
        fontSize: "1.3rem",
        fontWeight: 700,
        color: "var(--gold)",
        margin: 0,
      }}>
        {rate}
      </p>
      <p style={{
        fontSize: "0.9rem",
        color: "#64748b",
        margin: 0,
      }}>
        {distance}
      </p>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-wedding"
        style={{
          display: "inline-block",
          padding: "12px 36px",
          textDecoration: "none",
          fontSize: "0.95rem",
          marginTop: "8px",
        }}
      >
        {buttonText}
      </a>
    </div>
  );
}

export default function Hotels() {
  const { t } = useLanguage();

  return (
    <section id="hotels" style={{
      padding: "80px 20px",
      background: "linear-gradient(180deg, white 0%, var(--blue-50) 100%)",
    }}>
      <div style={{ textAlign: "center", marginBottom: "48px" }}>
        <p style={{
          letterSpacing: "3px",
          textTransform: "uppercase",
          fontSize: "0.85rem",
          color: "var(--blue-400)",
          marginBottom: "8px",
        }}>
          {t.hotelsSubtitle}
        </p>
        <h2 className="section-heading">{t.hotelsHeading}</h2>
        <div className="divider-ornament">
          <span style={{ color: "var(--gold)" }}></span>
        </div>
        <p style={{
          color: "#64748b",
          maxWidth: "600px",
          margin: "16px auto 0",
          lineHeight: 1.7,
        }}>
          {t.hotelsDescription}
        </p>
      </div>

      <div style={{
        maxWidth: "700px",
        margin: "0 auto",
        display: "flex",
        gap: "24px",
        flexWrap: "wrap",
        justifyContent: "center",
      }}>
        <HotelCard
          name={t.hotel1Name}
          rate={t.hotel1Rate}
          distance={t.hotel1Distance}
          buttonText={t.hotel1Button}
          url={CAMBRIA_URL}
        />
        <HotelCard
          name={t.hotel2Name}
          rate={t.hotel2Rate}
          distance={t.hotel2Distance}
          buttonText={t.hotel2Button}
          url={RESIDENCE_INN_URL}
        />
      </div>
    </section>
  );
}
